import {useState, useEffect} from 'react'
import { useAuth } from '../../context/AuthContext';

import { LiaMedalSolid } from "react-icons/lia";
import { IoStar } from "react-icons/io5";

import Header from '../../components/Header'
import RankingList from '../../components/RankingList';
import CodeRain from '../../components/CodeRain';

import XP_icone from '../../assets/imagens/icone_XP.png'

import { API_URL } from '../../config/api';
import './Ranking.css'
export default function Ranking() {

    const [ranking, setRanking] = useState([])
    const [userPosition, setUserPosition] = useState() 
    
    const token = localStorage.getItem('token')
    const {user, score} = useAuth()

    const getRanking = async() =>{
      await fetch(`${API_URL}/user/ranking/${user.id}`,{
            method: "GET",
            headers: {
                "Authorization": `Bearer ${token}`
            }
        })
            .then(response => {
                if (!response.ok) {
                throw new Error(`Erro: ${response.status}`);
                }
                return response.json(); 
                
            })
            .then(data => {
              console.log(data)
              setRanking(data.ranking)
              setUserPosition(data.userPosition)
             
            })
            .catch(error => {
                console.error('Erro na requisição:', error.message);
            });
        
        
    }

    useEffect(()=>{
      getRanking()
    
    },[])


    return(
        <>
        <Header />
        <CodeRain />
        <div className='ranking'>
            <div className="containerDefault"> 
                
                {/* <Podio ranking={ranking} /> */}
                <div className="flex resumo">
                    <div className="detalhe">
                        <h1>
                            {user.name}
                        </h1>
                        <h3>{user.email}</h3>
                    </div>
                    <div className="flex ">

                        <LiaMedalSolid color="var(--amarelo)" size={30}/>
                        <div >
                            <h1 className="numero">{userPosition && userPosition}°</h1>
                            <h3>no ranking</h3>
                        </div>
                        
                    </div>
                    <div className="flex">
                        <img className="icone" src={XP_icone} width={30} height={30}/>
                        <div>
                            <h1 className='numero'>{user.score}</h1>
                            <h3>Pontuação</h3>
                        </div>
                    </div>
                    <div className="flex">
                        <IoStar color="var(--amarelo)" size={30}/>
                        <div >
                            <h1 className="numero">{user.ticketsSolved}</h1>
                            <h3>Chamados resolvidos</h3>
                        </div>
                    </div>

                </div>
                <RankingList ranking={ranking} setRanking={setRanking} />
            </div>
        </div>
        
        </>
    )    
}